import styled from 'styled-components'

import { helpers } from 'styles'

import { Item as DefaultItem } from 'components/Lists/Expandable/Item/Item'

export const Item = styled(DefaultItem)`
	&:last-child {
		border-radius: 0 0 ${helpers.borderRadius} ${helpers.borderRadius};
	}
`
